import { render, staticRenderFns } from "./EmployeeFairPayCardHeader.vue?vue&type=template&id=19641bd1&scoped=true"
import script from "./EmployeeFairPayCardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeFairPayCardHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeFairPayCardHeader.vue?vue&type=style&index=0&id=19641bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19641bd1",
  null
  
)

export default component.exports